module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-06-09 at 3.55.50 PM.ae1181af.jpeg";